import { Mui } from "@osu/react-ui";
import { Link, useNavigate } from "react-router-dom";
import { useToggleActiveStatusMutation } from "../../services/graphql/api";

function ConfirmationDialog({ clear, close, isActivating, isBulk, reviewersToConfirm }) {
    const isOpen = reviewersToConfirm?.length > 0;
    const action = isActivating ? "Activating" : "Deactivating";
    const activeParam = isActivating ? "inactive" : "active";
    const color = isActivating ? "green" : "red";
    const reviewer_s = isBulk ? "reviewers" : "reviewer";
    const [updateReviewer, { isLoading, }] = useToggleActiveStatusMutation();
    const navigate = useNavigate();
    
    const confirmButtonLabel = !isLoading ? "Continue" : "Updating...";
    
    async function confirmAction() {
        const reviewerEmployeeId = reviewersToConfirm[0]?.id;
        const programId = reviewersToConfirm[0]?.programId;

        const payload = { reviewerEmployeeId, programId, activate: isActivating };
        await updateReviewer(payload);
        
        close();
        clear();
        navigate(`/reviewers/${activeParam}`);
    }
    
    return (
        <Mui.Dialog aria-label={`Confirm Reviewer ${action}`} fullWidth maxWidth="sm" onClose={close} open={isOpen}>
            <Mui.DialogTitle>{action} Reviewer</Mui.DialogTitle>
            
            <Mui.DialogContent>
                <Mui.DialogContentText component="span">
                    You are <span style={{ color, textTransform: "uppercase" }}>{action}</span> the selected {reviewer_s}:
                    
                    <ReviewersList isActivating={isActivating} reviewers={reviewersToConfirm} />

                    {!isActivating && <>Deactivating a reviewer will unassign all pending reviews</>}
                </Mui.DialogContentText>
            </Mui.DialogContent>
            
            <Mui.DialogActions>
                <Mui.Button aria-label="Cancel" color="secondary" onClick={close} disabled={isLoading ? true : false}>
                    Cancel
                </Mui.Button>
                <Mui.Button aria-label="Submit" color="primary" disabled={isLoading} onClick={confirmAction} size="medium" style={{ margin: "0 0 0 1rem" }} variant="contained">
                    { isLoading && <Mui.CircularProgress size={20} style={{ marginRight: ".5rem" }} /> }
                    {confirmButtonLabel}
                </Mui.Button>
            </Mui.DialogActions>
        </Mui.Dialog>
    );
}

function ReviewersList({ reviewers, isActivating }) {
    if (!(reviewers?.length > 0)) { return ""; }

    return (
        <ul style={{ marginTop: ".25em", marginBottom: ".5em" }}>
            {reviewers.map(reviewer => (
                <li key={reviewer.id}>
                    <ReviewerWithLink isActivating={isActivating} reviewer={reviewer} />
                </li>
            ))}
        </ul>
    );
}

function ReviewerWithLink({ reviewer, isActivating }) {
    if (isActivating) { return reviewer.name; }

    const pendingCount = reviewer.pending ?? "?";
    const reviewer_s = pendingCount !== 1 ? "reviews" : "review";
    const url = `/manage-applications/${reviewer.group}/${reviewer.employeeId}`;
    
    return (
        <>
            {reviewer.name} who has&nbsp;
            <Mui.Link component={Link} target="_blank" to={url}>{pendingCount} pending {reviewer_s}</Mui.Link>
        </>
    );
}

export default ConfirmationDialog;

